import React from "react";
import UserList from "../../Components/UserList";

const Investors = () => {
  return <UserList role="investor" roleLabel="Investors" />;
};

export default Investors;
